'use client';

import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import {
  isUpdateFeedNew,
  UPDATE_FEED_SEEN_EVENT
} from '#/lib/update-feed-seen';

interface UpdateNewBadgeProps {
  latestDate: string;
}

// 마지막 열람 이후 새 변경이 있을 때 "업데이트" 메뉴 옆에 붙는 배지
export function UpdateNewBadge({ latestDate }: UpdateNewBadgeProps) {
  // SSR/hydration mismatch 방지: 마운트 후에만 표시 여부 결정
  const [visible, setVisible] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    const check = () => setVisible(isUpdateFeedNew(latestDate));
    check();
    window.addEventListener(UPDATE_FEED_SEEN_EVENT, check);
    return () => window.removeEventListener(UPDATE_FEED_SEEN_EVENT, check);
  }, [latestDate, pathname]);

  if (!visible) return null;

  return (
    <span className="ml-1.5 inline-flex items-center rounded-full bg-[#104573] px-1.5 py-0.5 align-middle text-[10px] font-semibold leading-none text-white dark:bg-[#60a3d9] dark:text-[#0c1a2e]">
      더 바르게
    </span>
  );
}
